// Millisecond values
export const GET_PILLS_TO_RENDER_TIME_LIMIT: number = 2500;

export const SMART_PILL_CLICKED: string = 'SmartPillClicked';
export const SMART_PILL_MENU_OPENED: string = 'SmartPillMenuOpened';
export const SMART_TIME_MENU_CLICKED: string = 'SmartTimeMenuClicked';
export const SMART_DOC_MENU_CLICKED: string = 'SmartDocMenuClicked';
export const SMART_REPLY_MENU_CLICKED: string = 'SmartReplyMenuClicked';
